import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class AppointmentService {

    constructor(private httpService: HttpClient) { }

    getAppointments(analystId, timeZone, dateValue) {
        const myEncodedQueryParamValue = timeZone.replace("+", "%2B");
        const ecodeUrl = 'Appointments/available-slots?analystId=' + analystId + '&&timeZone=' + myEncodedQueryParamValue + '&&date=' + dateValue;
        return this.httpService.get(ecodeUrl);
    }
    bookAnAppointment(analystId, data) {
        return this.httpService.post('Appointments/schedule?analystId=' + analystId, data);
    }
    getAppointmentList(status) {
        return this.httpService.get('Appointments/my-appointments?skipSelf=true&type=' + status);
    }
    getTokboxDetails(appointmentId) {
        return this.httpService.get('Appointments/' + appointmentId + '/connect');
    }
    deleteAppointment(appointmentId) {
        return this.httpService.put(`Appointments/${appointmentId}/cancel`, {});
    }
    getArchives(appointmentId) {
        return this.httpService.get(`Appointments/${appointmentId}/archives`);
    }
    diconnectAppointment(appointmentId) {
        return this.httpService.post(`Appointments/${appointmentId}/disconnect`, {})
    }

    // Added for My projects -- EBS migration
    scheduleACall(serviceProviderId, data) {
        return this.httpService.post(`/appointments/schedule?serviceProviderId=${serviceProviderId}`, data);
    }
    getCommonAvailableSlots(data) {
        return this.httpService.post(`/user-calendar-configs/group-available-slots`, data);
    }
    scheduleGroupCall(requestData) {
        return this.httpService.post(`/appointments/schedule-group-call`, requestData);
    }
    getScheduleCallSPDetails(projectId: string) {
        return this.httpService.get(`/appointments/calendar-synced-service-providers?projectId=${projectId}`)
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/appointment.service.ts